export type ColumnKey = 'vin' | 'workshop' | 'customer';

export type ColumnSettings = Record<ColumnKey, boolean>;

export const COLUMN_SETTINGS_STORAGE_KEY = 'engineOil.table.columnSettings';

export const DEFAULT_COLUMN_SETTINGS: ColumnSettings = {
    vin: true,
    workshop: true,
    customer: true,
};

const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';

const COLUMN_KEYS = Object.keys(DEFAULT_COLUMN_SETTINGS) as ColumnKey[];

// Raw stored object, or null when absent, malformed, or storage is unavailable.
const parseStoredSettings = (): Partial<Record<ColumnKey, unknown>> | null => {
    try {
        const raw = window.localStorage.getItem(COLUMN_SETTINGS_STORAGE_KEY);
        return raw ? (JSON.parse(raw) as Partial<Record<ColumnKey, unknown>>) : null;
    } catch {
        return null;
    }
};

// Defaults overridden only by valid booleans, so bad/missing keys fall back safely.
export const readColumnSettings = (): ColumnSettings => {
    const stored = parseStoredSettings();
    const settings = { ...DEFAULT_COLUMN_SETTINGS };

    for (const key of COLUMN_KEYS) {
        const value = stored?.[key];
        if (isBoolean(value)) {
            settings[key] = value;
        }
    }

    return settings;
};

export const writeColumnSettings = (settings: ColumnSettings): void => {
    window.localStorage.setItem(COLUMN_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
};
